(ns frontend.components.inputs.multi-select
  (:require
   [clojure.string]
   [clojure.string :as string]
   [common.entity :as entity]
   [frontend.components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.components.inputs.select :as single-select]
   [frontend.components.open-search-select :as open-search-select]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [reagent.impl.component :as reagent-component]))


(defn force-remount?
  [prev-props new-props]
  (let [;;remounting if these props change - update list as needed:
        remount-prop-keys [:options :field/entity-types :entity/type :value :field/attribute]
        prev-remount-values (-> prev-props
                                (select-keys remount-prop-keys))
        new-remount-values (-> new-props
                               (select-keys remount-prop-keys))
        remount? (not= prev-remount-values new-remount-values)]
    remount?))

(defmethod editor :editor.type/multi-select
  [args]
  (let [dom-atom (r/atom nil)
        key-atom (r/atom (str (gensym "select-component")))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)
        use-ref-selector? (some #{(:field/data-type args)}
                                [:data.type/ref-multi :data.type/ref-single])]
    ;; ref vs atom
    (r/create-class
     {:display-name           "Multi-select"
      :component-did-mount    (fn [mount-args]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc
                                                               :temp-select-value))))               ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-did-update   (fn [this old-argv]
                                (let [prev-props (reagent-component/extract-props old-argv)
                                      new-props (r/props this)]))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [{:keys [on-blur!] :as args}]
                                (if use-ref-selector?
                                  (open-search-select/render-async-select-multi args)
                                  (single-select/render-select dom-atom
                                                               (assoc args
                                                                      :key-atom key-atom
                                                                      :is-multi true))))})))

(defmethod display-string :editor.type/multi-select
  [args]
  (let [value (:value args)
        selected (if (coll? value) value [value])
        options (:options args)
        labels (if (nil? options)
                 (->> selected
                      (keep session/get-entity)
                      (map (fn [entity]
                             (entity/display-string entity :short session/get-entity))))
                 (->> selected
                      (map (fn [s]
                             (let [js-s (clj->js s)]
                               (->> options
                                    (filter (fn [o]
                                              (or (= (:key o) s)
                                                  (= (:key o) js-s))))
                                    (first)
                                    (:label)))))))]
    (string/join ", " labels)))

(defmethod viewer :editor.type/multi-select
  [args]
  (r/create-class
   {:display-name "multi-select/viewer"
    :reagent-render
    (fn [args]
      (let [selected (:value args)
            component-id (:id args)
            attribute (:attribute args)
            options (:options args)]
        [:div.preview.preview-multi-select
         (->>
          selected
          (map (fn [v]
                 (let [label (or (->> options
                                      (filter (fn [o]
                                                (or (= (:key o) v)
                                                    (= (:keyword o) v))))
                                      (first)
                                      :label)
                                 (when (number? v)
                                   (let [entity (session/get-entity v)]
                                     (entity/display-string entity :short session/get-entity))))
                       clickable? (and (number? v)
                                       (let [entity-type (:entity/type (get @session/entities v))]
                                         (some #{entity-type} routing/clickable-entity-types)))]
                   (if clickable?
                     [:span
                      {:key      (str component-id "-comp-" attribute "-" v)
                       :href     "#"
                       :on-click (fn [e]
                                   (routing/open-entity v)
                                   (.preventDefault e))}
                      label]
                     [:span {:key (str component-id "-comp-" attribute "-" v)}
                      label]))))
          (doall))]))}))
